/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";
import {BaseComponent, NodeRendererProps} from "@intuitionrobotics/thunderstorm/frontend";
import {FONTS} from "@res/fonts";
import {AlertStatusChange} from "./AlertRow";
import * as emotion from "emotion";
import {COLORS} from "@res/colors";
import {AlertsModule} from "@modules/AlertsModule";
import {AlertStatus, DB_Alert} from "@app/app-shared/alert";
import {AnalyticConsts, AnalyticsModule} from "@modules/AnalyticsModule";
import {Dialog_AlertFeedback} from "../../../dialogs/Dialog_AlertFeedback";
import {PatientsContext} from "../patients/PatientsContext";

export const hoverStyle = emotion.css(
    {
        ":hover": {
            cursor: "pointer",
            backgroundColor: COLORS.primary_blue_10,
            color: COLORS.primary_blue
        }
    }
);

export class StatusEntry
    extends BaseComponent<NodeRendererProps<AlertStatusChange>, {}> {

    constructor(props: NodeRendererProps<AlertStatusChange>) {
        super(props);
    }

    private prettyLabel = (label: string) => {
        switch (label) {
            case AlertStatus.OPEN:
            case AlertStatus.NEW:
                return "Open";
            case AlertStatus.COMPLETE:
                return "Complete";
            case AlertStatus.IN_PROGRESS:
                return "In progress";
            default:
                return label;
        }
    };

    render() {

        return <PatientsContext.Consumer>{
            ({demo}) => <div
                className={hoverStyle}
                style={{display: "flex", padding: "10px", whiteSpace: "nowrap"}}
                onClick={() => {
                    if (demo)
                        return this.props.item.onSelect();

                    const alert = this.props.item.alert;

                    // No change, do nothing.
                    if (this.isStatusTheSame(alert)) {
                        return this.props.item.onSelect();
                    }

                    // How to handle change, when currently it's COMPLETE?
                    if (alert.status === AlertStatus.COMPLETE) {
                        //	Do nothing for now.
                    }

                    if (this.props.item.status === AlertStatus.COMPLETE) {
                        Dialog_AlertFeedback.show(
                            this.props.item.feedbackCategories.feedback,
                            alert,
                            this.props.item.onFeedbackSubmit
                        );
                        this.props.item.onSelect();
                        return;
                    }

                    alert.status = this.props.item.status;
                    this.props.item.onSelect();
                    AnalyticsModule.logCareManagerEvent({
                        objectType: AnalyticConsts.ObjectTypes.CUSTOMERS,
                        entity: AnalyticConsts.Entities.USER,
                        activityStatus: alert.status.toLowerCase(),
                        objectSubType: AnalyticConsts.ObjectSubTypes.DASHBOARD,
                        activityDetails: AnalyticConsts.ActivityDetails.NOTIFICATION_CHANGE,
                        objectId: alert._id
                    });

                    AlertsModule.update({...alert});
                }
                }>
                {this.props.item.icon}
                <div style={{paddingLeft: "5px"}}>
                    {FONTS.reg_14(this.prettyLabel(this.props.item.status))}
                </div>
            </div>
        }</PatientsContext.Consumer>;
    }

    private isStatusTheSame = (alert: DB_Alert<any>) => {
        return this.prettyLabel(alert.status) === this.prettyLabel(this.props.item.status);
    };
}
